import { render, staticRenderFns } from "./Component-TaskProcess.vue?vue&type=template&id=00f45a48&"
import script from "./Component-TaskProcess.vue?vue&type=script&lang=js&"
export * from "./Component-TaskProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports